import React from "react";

function Card(props) {
    return (
        <div
            className={`${props.className} rounded-16 bg-white-dark shadow-btn text-center `}
            id={props.id}
        >
            {props.children}
        </div>
    );
}

export default Card;
